import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { Transition } from "react-transition-group";
import { isNumber } from "es-toolkit/compat";
import { useCombinedRefs } from "../../hooks/useCombinedRefs.js";
const DEFAULT_TIMEOUT = 300;
const Fade = /*#__PURE__*/ forwardRef(({ children, timeout = DEFAULT_TIMEOUT, onEntering, onEntered, onExiting, onExited, style, visible = false, testId, unmountOnExit = true, as, ...props }, ref)=>{
    const As = as ?? 'div';
    const internalRef = useRef(null);
    const combinedRefs = useCombinedRefs(ref, internalRef);
    const getTransitionDelay = (state)=>{
        if (isNumber(timeout)) return timeout;
        const isEntering = 'entering' === state || 'entered' === state;
        return timeout[isEntering ? 'enter' : 'exit'] ?? DEFAULT_TIMEOUT;
    };
    const transitionStyles = {
        entering: {
            opacity: '1'
        },
        entered: {
            opacity: '1'
        },
        exiting: {
            opacity: '0'
        },
        exited: {
            opacity: '0',
            pointerEvents: 'none'
        },
        unmounted: {
            opacity: '0'
        }
    };
    return /*#__PURE__*/ jsx(Transition, {
        unmountOnExit: unmountOnExit,
        timeout: timeout,
        in: visible,
        nodeRef: internalRef,
        onEntering: onEntering,
        onEntered: onEntered,
        onExiting: onExiting,
        onExited: onExited,
        children: (state)=>/*#__PURE__*/ jsx(As, {
                style: {
                    transition: `opacity ${getTransitionDelay(state)}ms ease-in-out`,
                    ...transitionStyles[state],
                    ...style
                },
                "data-transitioning": [
                    'entering',
                    'exiting'
                ].includes(state),
                "aria-hidden": [
                    'exiting',
                    'exited'
                ].includes(state),
                "data-testid": testId,
                ...props,
                ref: combinedRefs,
                children: children
            })
    });
});
Fade.displayName = 'Fade';
export { Fade };
